// 囤货到日本国际物流展示
export const STOCK_JP_SHIPPING = 1;
// 日本商品采购权限
export const JP_GOODS_PURCHASE = 2;

// 日本商品采购权限(有TIKTOK)
export const JP_GOODS_PURCHASE_HAS_TIKTOK = 3;
// 是否是crossmall白名单
export const JP_CROSS_MALL_WHITE = 4;

export const data = [
    // 个人中心
    {
        label: window._$m.t('我的工作台'),
        icon: 'workbanch',
        menulink: '/user/UserCenter'
    },
    // 订单
    {
        label: window._$m.t('订单管理'),
        icon: 'order',
        children: [
            {
                label: window._$m.t('API同步订单'),
                plat: 'd2c',
                site: ['ja', 'ko', 'en'],
                menulink: '/order/SyncOrder'
            },
            {
                label: window._$m.t('我的订单'),
                menulink: '/order/OrderList'
            },
            {
                label: window._$m.t('异常订单'),
                menulink: '/order/AbnormalOrder'
            }
        ]
    },
    // 商品
    {
        label: window._$m.t('商品管理'),
        icon: 'product',
        children: [
            {
                label: window._$m.t('库存管理'),
                menulink: '/product/stock'
            },
            {
                label: window._$m.t('组合商品管理'),
                menulink: '/product/CombinedGoods'
            },
            {
                label: window._$m.t('同步商品'),
                menulink: '/product/AbnormalOrder',
                plat: 'b2b',
                site: ['ja', 'ko']
            },
            {
                label: 'CROSS MALL店舗商品取込',
                menulink: '/product/CrossSyncProduct',
                plat: 'b2b',
                site: ['ja'],
                showAuth: [JP_CROSS_MALL_WHITE]
            },
            {
                label: window._$m.t('品牌授权'),
                menulink: '/product/brandmanage'
            },
            {
                label: window._$m.t('我的商品测量结果'),
                menulink: '/product/brandmanage'
            },
            {
                label: window._$m.t('关联商品库'),
                menulink: '/product/AssociatedProductlib',
                plat: 'd2c',
                site: ['ja', 'ko', 'en']
            },
            {
                label: window._$m.t('我的收藏'),
                menulink: '/product/CollectProduct'
            },
            {
                label: window._$m.t('购买过'),
                menulink: '/product/AfterPurchase'
            },
            {
                label: window._$m.t('足迹'),
                menulink: '/product/FootPrint'
            }
        ]
    },
    // 备货到日本
    {
        label: '日本倉庫搬送依頼',
        icon: 'inShipping',
        plat: 'd2c',
        showAuth: [STOCK_JP_SHIPPING],
        children: [
            {
                label: '搬送依赖一覧',
                menulink: '/inshipping_d2c/ShippingList_d2c'
            }
        ]
    },
    // 采购管理
    {
        label: window._$m.t('采购管理'),
        icon: 'purchase',
        plat: 'd2c',
        // 只有满足条件才会展示，没有值默认展示
        showAuth: [JP_GOODS_PURCHASE, JP_GOODS_PURCHASE_HAS_TIKTOK],
        children: [
            {
                label: window._$m.t('日本商品采购计划'),
                menulink: '/purchaseManage/list',
                showAuth: [JP_GOODS_PURCHASE_HAS_TIKTOK]
            },
            {
                label: '入荷予定（日本倉庫）',
                plat: 'd2c',
                site: ['ja'],
                showAuth: [JP_GOODS_PURCHASE_HAS_TIKTOK],
                menulink: '/purchaseManage/EntrySchedule'
            }
        ]
    },
    // 国际物流
    {
        label: window._$m.t('国际配送管理'),
        icon: 'inShipping',
        plat: 'b2b',
        children: [
            {
                label: window._$m.t('FBA补货计划'),
                menulink: '/inshipping/ReplenishmentList',
                site: ['ja']
            },
            {
                label: window._$m.t('国际发货管理'),
                menulink: '/inshipping/ShippingList'
            },
            {
                label: window._$m.t('国际发货售后'),
                menulink: '/inshipping/ShippingList'
            }
        ]
    },
    // 资金管理
    {
        label: window._$m.t('资金管理'),
        icon: 'fund',
        children: [
            {
                label: window._$m.t('资金明细'),
                menulink: '/fund/CustomerFund'
            },
            {
                label: window._$m.t('我的账单'),
                menulink: '/fund/BillList?type=1'
            }
        ]
    },
    // oem
    {
        label: 'OEM',
        icon: 'oem',
        children: [
            {
                label: window._$m.t('新增寻源任务'),
                menulink: '/oem/order/addFindSource'
            },
            {
                label: window._$m.t('寻源列表'),
                menulink: '/oem/order/oemSourceList'
            },
            {
                label: window._$m.t('OEM商品'),
                menulink: '/oem/goods/list'
            }
        ]
    },
    // 店铺管理
    {
        label: window._$m.t('店铺管理'),
        icon: 'store',
        children: [
            {
                label: window._$m.t('店铺配置'),
                menulink: '/authorized/setupShop'
            },
            {
                label: window._$m.t('API/子账号配置'),
                menulink: '/authorized/AuthorizedStore'
            }
        ]
    },
    // 会员
    {
        label: window._$m.t('会员相关'),
        icon: 'vip',
        children: [
            {
                label: window._$m.t('会员办理'),
                menulink: '/vip/VipLevel'
            },
            {
                label: window._$m.t('消息'),
                menulink: '/vip/Information'
            },
            {
                label: window._$m.t('登录账号管理'),
                menulink: '/vip/setupUser'
            }
        ]
    },
    // 成本计算器
    {
        label: window._$m.t('应用工具'),
        icon: 'applicationTool',
        children: [
            {
                label: window._$m.t('成本计算器'),
                menulink: '/costCalc/list'
            }
        ]
    }
];
